import { createFeatureSelector, createSelector, MemoizedSelector } from '@ngrx/store';
import { LoadStatus } from '../../load-status';
import { RecipientEntryState, RECIPIENTS_FEATURE_KEY, RecipientsCollectionState } from '../recipients-collection.state';
import { NotificationStateUtilities } from '../../utilities/notification-state-utlities';
import { NotificationIdState } from '../../utilities/notification-id.type';

export const selectRecipientsFeature = createFeatureSelector<RecipientsCollectionState>(RECIPIENTS_FEATURE_KEY);

/** The full saved-recipients collection. This is also the persistence-layer projection. */
export const selectRecipientsEntries = createSelector(selectRecipientsFeature, (state) => state.entries);

export const selectRecipientsStatus = createSelector(selectRecipientsFeature, (state) => state.loadStatus);

export const selectRecipientsLoaded = createSelector(selectRecipientsStatus, (status) => status === LoadStatus.Loaded);

export const selectRecipientsError = createSelector(selectRecipientsFeature, (state) => state.error);

/**
 * The recipients saved under `notificationId`, or `undefined` when no entry exists for it.
 * Returning `undefined` (rather than `[]`) for an absent entry is load-bearing:
 * `ConfirmationServiceReportModel` branches on it to fall back to the NDP email set.
 *
 * @param notificationId the notification id to look up
 * @returns a selector for the recipients saved under `notificationId`
 */
export const selectRecipientsForNotificationId = (
    notificationId: NotificationIdState,
): MemoizedSelector<object, RecipientEntryState[] | undefined> =>
    createSelector(
        selectRecipientsEntries,
        (entries): RecipientEntryState[] | undefined =>
            entries.find((entry) => NotificationStateUtilities.compare(entry.notificationId, notificationId))
                ?.recipients,
    );
